import React from 'react';
import { DateStepper, MonthStepper } from '../ui/date-stepper';

const DashboardControls = ({ plants, dashboardPlant, setDashboardPlant, viewMode, setViewMode,
  selectedDate, setSelectedDate, selectedYear, setSelectedYear, selectedMonth, setSelectedMonth }) => (
  <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
      {viewMode !== 'compare' && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Plant</label>
          <select
            value={dashboardPlant?.id || 'all'}
            onChange={(e) => {
              if (e.target.value === 'all') {
                setDashboardPlant({ id: 'all', name: 'All Plants (Consolidated)' });
              } else {
                setDashboardPlant(plants.find(p => p.id === e.target.value));
              }
            }}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#156ACA]"
            data-testid="dashboard-plant-select"
          >
            <option value="all">All Plants (Consolidated)</option>
            {plants.map(plant => (
              <option key={plant.id} value={plant.id}>{plant.name}</option>
            ))}
          </select>
        </div>
      )}

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">View</label>
        <select
          value={viewMode}
          onChange={(e) => setViewMode(e.target.value)}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#156ACA]"
          data-testid="dashboard-view-select"
        >
          <option value="daily">Daily</option>
          <option value="mtd">Month-to-Date (MTD)</option>
          <option value="ytd">Year-to-Date (YTD)</option>
          <option value="yearly">Year-over-Year Comparison</option>
          <option value="compare">Compare Plants (Daily)</option>
          <option value="utilization">Utilization (FY)</option>
          <option value="stoppage">Plant Stoppages</option>
          <option value="fy_matrix">FY Production Matrix</option>
        </select>
      </div>

      {(viewMode === 'daily' || viewMode === 'compare') && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Date</label>
          <DateStepper
            value={selectedDate}
            onChange={setSelectedDate}
            testidPrefix="dashboard-date"
          />
        </div>
      )}

      {(viewMode === 'mtd' || viewMode === 'ytd' || viewMode === 'yearly') && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">{(viewMode === 'ytd' || viewMode === 'yearly') ? 'Fiscal Year' : 'Year'}</label>
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(parseInt(e.target.value))}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#156ACA]"
            data-testid="dashboard-year-select"
          >
            {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - 2 + i).map(y => (
              <option key={y} value={y}>
                {(viewMode === 'ytd' || viewMode === 'yearly') ? `FY ${y}-${String(y + 1).slice(-2)}` : y}
              </option>
            ))}
          </select>
        </div>
      )}

      {viewMode === 'mtd' && (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Month</label>
          <MonthStepper
            year={selectedYear}
            month={selectedMonth}
            onMonthChange={setSelectedMonth}
            onYearChange={setSelectedYear}
            testidPrefix="dashboard-month"
          />
        </div>
      )}
    </div>
  </div>
);

export default DashboardControls;
